import React, { useState } from "react";
import styled from "styled-components";
import {
  AppleIcon,
  AuthArrow,
  FacebookIcon,
  GoogleIcon,
  LoginMailIcon,
  PasswordIcon,
  PhoneIcon,
  RegisterImg,
  UserIcon,
  WebLogo,
  WebLogoMain,
} from "../utils/Images";
import { useNavigate } from "react-router-dom";
import RegisterSteps from "./RegisterSteps";
import { checkavailability, sendotp } from "../collection/ApiCollection";
import { toast } from "react-toastify";
import { Field, Form, Formik } from "formik";
import { cousntryCodesArr } from "../utils/constants";
import * as Yup from "yup";

const Register = () => {
  const navigate = useNavigate();
  const [openRegisterStepsModal, setOpenRegisterStepsModal] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [countryCode, setCountryCode] = useState("+1");
  const [modalData, setModalData] = useState(null);
  const [loader, setLoader] = useState(false);
  const handleInputCheck = (e) => {
    const value = e.target.value;
    setInputValue(value);
  };

  const isPhoneNumber = (value) => {
    return /^\d+$/.test(value) && value.length > 6; // Adjust length check based on typical phone numbers
  };

  const checkType = isPhoneNumber(inputValue);
  console.log(checkType, "checkType");

  const handleOpenRegisterStepsModal = () => {
    setOpenRegisterStepsModal(true);
  };
  const handleCancelRegisterStepsModal = () => {
    setOpenRegisterStepsModal(false);
  };
  const initialValues = {
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
  };
  const validationSchema = Yup.object().shape({
    fullName: Yup.string()
      .matches(
        /^[A-Za-z\s]+$/,
        "Full Name cannot contain numbers or special characters"
      )
      .required("Full Name is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Password must contain at least one special character"
      )
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });
  const handleCheckAvailibility = async (values) => {
    if (inputValue == "") {
      toast.error("Email or number is required");
      return;
    }
    setModalData(values);
    setLoader(true);

    try {
      const params = new URLSearchParams();
      if (checkType) {
        params.append("phoneNumber", inputValue);
        params.append("countryCode", countryCode);
      } else {
        params.append("email", inputValue);
      }
      let res = await checkavailability(params.toString());
      console.log(res, "availll");
      if (res.status === 200) {
        const reqForNum = {
          phoneNumber: inputValue,
          countryCode: countryCode,
          type: "sms",
        };
        const reqForEmail = {
          email: inputValue,
          type: "email",
        };
        try {
          let res = await sendotp(checkType ? reqForNum : reqForEmail);
          if (res.status === 200) {
            toast.success(res?.data?.message);
            handleOpenRegisterStepsModal();
            setLoader(false);
          } else {
            toast.error(
              res?.response?.data?.message ||
                res?.error ||
                res?.message ||
                "Something went wrong"
            );
            setLoader(false);
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.message ||
              error?.error ||
              error?.message ||
              "Something went wrong"
          );
          setLoader(false);
        }
      } else {
        toast.error(
          res?.response?.data?.message ||
            res?.error ||
            res?.message ||
            "Something went wrong"
        );
        setLoader(false);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.errors?.[0]?.msg ||
          error?.response?.data?.message ||
          error?.error ||
          error?.message ||
          "Something went wrong"
      );
      setLoader(false);
    }
  };

  return (
    <RegisterWrapper>
      {openRegisterStepsModal && (
        <RegisterSteps
          openRegisterStepsModal={openRegisterStepsModal}
          handleCancelRegisterStepsModal={handleCancelRegisterStepsModal}
          inputValue={inputValue}
          countryCode={countryCode}
          checkType={checkType}
          modalData={modalData}
        />
      )}
      <div className="left-side">
        <img
          src={WebLogoMain}
          alt=""
          width={80}
          height={68}
          className="webLogo"
          onClick={() => navigate("/")}
        />
        <div className="inner-div">
          <div className="main-content">
            <h1>
              Welcome to Sophie <br />
              Sign into your account
            </h1>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleCheckAvailibility}
              validateOnChange={false} // Keep default validation for other fields
              validateOnBlur={true}
            >
              {({ errors, touched, values, setFieldValue }) => (
                <Form>
                  <div className="input-div">
                    <div>
                      <img src={UserIcon} alt="" className="mail-icon" />
                      <Field
                        type="text"
                        name="fullName"
                        placeholder="Full name"
                      />
                    </div>
                    {errors.fullName && touched.fullName && (
                      <p className="error-div">{errors.fullName}</p>
                    )}
                    {/*<div>
                                        <img src={LoginMailIcon} alt="" className='mail-icon' />
                                          <Field type='text' name='email' placeholder='Email or Phone number' />

                                    </div>*/}
                    <div style={{ border: "none", padding: "0px" }}>
                      {isPhoneNumber(inputValue) && (
                        <select
                          value={countryCode}
                          onChange={(e) => setCountryCode(e.target.value)}
                          style={{ marginRight: "8px" }}
                          className="country-code"
                        >
                          {cousntryCodesArr?.map((val) => {
                            return (
                              <option value={val?.code}>
                                {val?.code} {val?.name}
                              </option>
                            );
                          })}
                        </select>
                      )}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "0px",
                        }}
                      >
                        <input
                          type="text"
                          value={inputValue}
                          onChange={handleInputCheck}
                          placeholder="Email or Phone number"
                        />
                        <img
                          src={
                            isPhoneNumber(inputValue)
                              ? PhoneIcon
                              : LoginMailIcon
                          }
                          alt=""
                          className="mail-icon"
                        />
                      </div>
                    </div>
                    <div>
                      <img src={PasswordIcon} alt="" className="mail-icon" />
                      <Field
                        type="password"
                        name="password"
                        placeholder="Enter password"
                        value={values.password}
                        onChange={(e) => {
                          setFieldValue("password", e.target.value, true); // "true" triggers validation
                        }}
                      />
                    </div>
                    {errors.password && (
                      <p className="error-div">{errors.password}</p>
                    )}
                    <div>
                      <img src={PasswordIcon} alt="" className="mail-icon" />
                      <Field
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm password"
                      />
                    </div>
                    {errors.confirmPassword && touched.confirmPassword && (
                      <p className="error-div">{errors.confirmPassword}</p>
                    )}
                  </div>
                  <div className="signin-method">
                    <button type="submit">
                      {loader ? (
                        "Loading..."
                      ) : (
                        <>
                          REGISTER <img src={AuthArrow} alt="" />
                        </>
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>

            <p className="or-div">OR</p>
            <div className="log-in-with">
              <p>
                <img src={GoogleIcon} alt="" />
                Login with Google
              </p>
              <p>
                <img src={FacebookIcon} alt="" />
                Login with Facebook
              </p>
              <p>
                <img src={AppleIcon} alt="" />
                Login with Apple
              </p>
            </div>
            <p className="dont-have-account" onClick={() => navigate("/login")}>
              Already have an account? <span>Log in</span>
            </p>
          </div>
        </div>
      </div>
      <div className="right-side">
        <img src={RegisterImg} alt="" />
      </div>
    </RegisterWrapper>
  );
};

export default Register;

const RegisterWrapper = styled.div`
  display: flex;
  height: 100%;
  .left-side {
    width: 41%;
    position: relative;
    padding-bottom: 29px;
    height: 100%;

    @media (max-width: 1050px) {
      width: 100%;
    }

    .webLogo {
      position: absolute;
      left: 71px;
      top: 29px;
      cursor: pointer;
    }
    .inner-div {
      width: 65%;
      margin: auto;
      margin-top: 154px;

      @media (max-width: 750px) {
        width: 85%;
      }

      .main-content {
        h1 {
          font-weight: 700;
          font-size: 21px;
          text-align: center;
        }
        .input-div {
          div {
            margin: auto;
            margin-top: 31px;
            border: 1px solid #e4dfdf;
            border-radius: 12px;
            height: 70px;
            display: flex;
            align-items: center;
            gap: 15px;
            position: relative;
            max-width: 383px;
            width: 100%;

            .country-code {
              height: 70px;
              border-radius: 12px;
              border: 1px solid #e4dfdf;
            }

            .mail-icon {
              width: 27px;
              height: 27px;
              position: absolute;
              z-index: 9;
              left: 20px;
            }
            .eye-icon {
              width: 29px;
              height: 30px;
              position: absolute;
              z-index: 9;
              right: 20px;
            }
            input {
              font-size: 14px;
              font-weight: 400;
              border: none;
              height: 100%;
              position: relative;
              padding: 0px 60px;
              border-radius: 12px;
              width: 100%;

              &:focus {
                outline: none;
              }
            }
          }
          .error-div {
            color: red;
            margin-top: 5px;
            margin-left: 13px;

            @media (max-width: 1050px) {
              width: max-content;
              margin: auto;
              margin-top: 5px;
            }
          }
        }
        .forget-pas-div {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 34px;
          margin-bottom: 25px;

          .for-flex {
            display: flex;
            align-items: center;
            gap: 5px;
          }
          p {
            font-size: 14px;
            font-weight: 400;
          }
        }
        .signin-method {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 48px;

          button {
            color: #fff;
            font-size: 16px;
            font-weight: 400;
            background: #0da982;
            height: 48px;
            padding: 0px 30px;
            position: relative;
            border: none;
            border-radius: 15px;
            display: flex;
            align-items: center;
            max-width: 225px;
            width: 100%;
            justify-content: center;
            cursor: pointer;

            img {
              position: absolute;
              width: 24px;
              height: 24px;
              right: 10px;
            }
          }
        }
        .or-div {
          font-size: 16px;
          font-weight: 500;
          color: #9d9898;
          margin-top: 15px;
          margin-bottom: 25px;
          text-align: center;
        }
        .log-in-with {
          display: flex;
          flex-direction: column;
          gap: 17px;
          align-items: center;

          p {
            font-size: 16px;
            font-weight: 400;
            box-shadow: 15px 0px 30px 0px #d3d4e240;
            border-radius: 12px;
            height: 60px;
            max-width: 283.64px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 20px;

            img {
              width: 28px;
              height: 28px;
            }
          }
        }
        .dont-have-account {
          font-size: 15px;
          font-size: 400;
          margin-top: 29px;
          cursor: pointer;
          text-align: center;

          span {
            color: #5669ff;
          }
        }
      }
    }
  }
  .right-side {
    width: 59%;

    @media (max-width: 1050px) {
      display: none;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
`;
